import { render, staticRenderFns } from "./RelatedActivities.vue?vue&type=template&id=6d9f78fc&"
import script from "./RelatedActivities.vue?vue&type=script&lang=js&"
export * from "./RelatedActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports